import { useState, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Container from '@material-ui/core/Container'

import FormComponent from '../component/um/preference/Form'
// import Line from '../component/um/preference/Line'

import usePreferanceProfile, { FormProps } from '../services/um/usePreferenceProfile'
import useAuthenStore from '../stores/authen/authenStore'
import useLogin from '../services/authen/useLogin'
import useAuthenAction from '../stores/authen/authenAction'
import useTranslate from '../i18n/useTranslate'
import Dialog, { DialogType } from '../control/dialog/dialog'

const Profile = () => {
    const classes = useStyles()
    const t = useTranslate()
    const authenStore = useAuthenStore()
    const authenAction = useAuthenAction()
    const { getProfile } = useLogin()
    const { putPreferanceProfile } = usePreferanceProfile()

    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    const getNewProfile = async () => {
        const token = localStorage.getItem('accessToken')
        let loginType = null as 1 | 2 | null
        if (localStorage.getItem('loginType') && localStorage.getItem('loginType') === '1') {
            loginType = 1
        } else if (localStorage.getItem('loginType') && localStorage.getItem('loginType') === '2') {
            loginType = 2
        }
        if (loginType) {
            const profileRes = await getProfile(`${token}`, loginType)
            authenAction.setProfile(profileRes)
        }
    }

    const onSaveInformation = async (values: FormProps) => {
        setConfigDialog({
            title: t.get('ALERT.TITLE.NOTIFICATION'),
            content: t.get('ALERT.CONTENT.NEED_TO_SAVE'),
            type: 'alert-confirm',
            onClickConfirm: () => save(values),
        })

        dialogTwoRef.current?.openDialog()
    }

    const save = async (values: any) => {
        const result = await putPreferanceProfile(authenStore.profile.userId, values)
        if (result.message === 'success') {
            setConfigDialog({
                title: t.get('ALERT.TITLE.NOTIFICATION'),
                content: t.get('ALERT.CONTENT.SAVE_SUCCESS'),
                type: 'alert-message',
                onAfterClose: getNewProfile,
            })
            return
        } else {
            setConfigDialog({
                title: t.get('ALERT.TITLE.ERROR'),
                content: t.get('ALERT.CONTENT.SAVE_NOT_SUCCESS'),
                type: 'alert-message',
            })
        }
    }

    return (
        <Container maxWidth="lg" className={classes.container}>
            <Paper elevation={3} variant="outlined" className={classes.root}>
                <FormComponent onSaveInformation={onSaveInformation} getNewProfile={getNewProfile} />
                {/* <Line /> */}
                <Dialog onRef={onRefDialogTwo} {...configDialog} />
            </Paper>
        </Container>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(2),
        },
    },
    container: {
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(1),
        },
    },
}))

export default Profile
